import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';

export function hasTruthyProperty<T extends object>(obj: T, path: string | Array<string | number>): boolean {
  const value = get(obj, path);

  if (value == null) return false;

  if (isPlainObject(value)) {
    return Object.values(value as Record<string, unknown>).some(Boolean);
  }

  return Boolean(value);
}
